<template>
  <div class="SearchResult">
    <top-component></top-component>
    <SearchComponent @submitForm="submitForm"></SearchComponent>
    <div class="Coalition-content content rep-list-con" v-show="resultShow">
        <div class="opera_c">
            <el-button size="small" class="return numtip jsd"   @click="addInvent()">批量订购
                    <el-tooltip placement="right" v-if="+num">
                        <div slot="content">共{{ num }}条，总码洋{{ myTotal.toFixed(2) }}元<em class="el-icon-delete numdetail" @click="clearCheck" title="一键清除勾选记住的数据"></em></div>
                        <i>({{ num }})</i>
                    </el-tooltip>
                </el-button>
                <add-car-all :queryData="queryData" :total="total" @return="returnMsg" class="jsd"></add-car-all>
            <div class="sortbox fl sortbox2"><Sort :sortList="sortList" @selectedData="orderByField"></Sort></div> 
        </div>
        <div id="replist" contenteditable="true">
            <table-list :tableParam="tableParam" @change="tableChange" ref="reptable" class="rep-list"></table-list>
        </div>
        <div class="table-wrap">
            <el-pagination class="pagi-wrap" :current-page.async="page" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="size"  :page-sizes="[10,20, 50]" :total="total" layout="total, sizes, prev, pager, next, jumper" />
        </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponentcopy.vue'
  import TableList from '../Components/TableList.vue'
  import Sort from '../Components/Sort.vue'
import { getsearchresult,shoppingCartnum } from '@/api/pages'
  import {Pagination,Button,Tooltip,Loading} from 'element-ui'
  import popup from '../../common/plugin/dialog/index.js'
  import AddInventory from '../../components/AddInventory'
  import AddCarAll from '../../components/AddCarAll'
  import SearchComponent from '../../components/SearchComponent'
//   import Sort from '../Components/Sort.vue'
//   import { searchpageCity } from '@/api/img'
//   import { addMoreOrder} from '@/api/common'
  import Axios from '@/api/diyaxios'

  import Cookies from 'js-cookie'
  export default {
    name: 'SearchResult',
    // props:[ 'isShowType' ],
    data() {
      return {
        // dataAll: [],
        // childrens: []
        total0:0,
        total:0,
        page:1,
        size:20,
        myTotal:0,
        num: 0,  //加入收订条数
        myTotal:0,  //加入收订总码洋
        sortRule: {"cbny":"desc"},
        addivent_pop:null,
        tableLoading:null,
        paramsData:null,//查询参数
        resultShow:false,
        queryData:{},//全部加入购物车 查询参数
        sortList:[
            {name:'出版社',value:'cbs'},
            {name:'出版时间',value:'cbny'},
            {name:'中图法',value:'classifycode'},
            {name:'码洋',value:'dj'},
            {name:'图书销售排行',value:'dj'}
        ],
         tableParam: {
            dataRes: { entities: null }, //接口数据data
            isCheckbox: true,
            isCurrentRow: true,
            isDragSelected: true,
            isRemindCheck: true,
            // isSort: true,
            columns: [
                { prop: 'isbn', label: 'ISBN', isSort: false },
                { prop: 'title', label: '书名',  isSort: false ,align:'left'},
                { prop: 'author', label: '作者', isSort: false ,align:'left'},
                { prop: 'publisher', label: '出版社', isSort: false ,align:'left'},
                { prop: 'publishTime', label: '出版时间', isSort: false },
                { prop: 'cnIbraryType', label: '中图法分类', isSort: false },
                { prop: 'subjectName', label: '学科分类', isSort: false ,align:'left'},
                { prop: 'publicName', label: '大众分类', isSort: false ,align:'left'},
                // { prop: 'cc', label: '尺寸(cm)', isSort: false },
                // { prop: 'dzlx', label: '适用对象', isSort: false},  //610 适用对象
                { prop: 'layout', label: '装帧', isSort: false},
                { prop: 'price', label: '码洋（￥）', isSort: false },
                { prop: 'selectNum', label: '是否订购', isSort: false, enum:true , enumDeel: function(index, row){
                    return row.selectNum == 0 ? '否':'是';
                }},
                {
                    prop: 'cz', label: '操作', isChange: true, isHide: false, deel: [
                        { str: '详情', event: 'toDetail' }
                    ]
                }
            ],
            isPagination: false, // 是否有分页
            totalCount: 0,
        },
        choosedData:[]
      }
    },
    mounted() {
        let vm = this;
    //   console.log(this.$route.params.areaName)
    //   // this.DiFangDataList()
    //   this.AllDiFangDataList()

        document.getElementById('replist').focus();
        document.getElementById('replist').addEventListener('keydown', function(ev){
            if(vm.tableParam.dataRes.entities){
                let key = window.event.keyCode;
                vm.$refs.reptable.onKeyDownChange(ev, key, vm.tableParam);
                // vm.$refs.reptable.onScrollCurrentChange();
            }
        }, false);
        // vm.queryList();
    },
    watch:{
        total(val){
            if(val > 10000){
                let _total = document.getElementsByClassName('el-pagination__total');
                _total.innerHTML='最多展示10000条';
            }
        },
        choosedData(val){
            this.num = this.choosedData.length;
            this.myTotal = 0;
            this.choosedData.forEach((ele, i) => {
                if(ele.price) this.myTotal += +ele.price;
            });
        },
    },
    methods: {
        orderByField(data) {
            let vm = this,
                bool = vm.emptyObj(data);
            vm.sortRule = bool ? data : null;
            vm.page = 1;
            vm.queryList();
        },
       getQueryMsg() {
            let vm = this,
            query_msg = this.paramsData || {};
            query_msg['sortRules'] = JSON.stringify(vm.sortRule);   
            query_msg['userid'] = Cookies.get('UserID') || '';  

            vm.queryData = query_msg;
            return query_msg;
        },
        loading(){
             let loading = Loading.service({
                target: 'body',
                spinner: 'el-icon-loading',
                text: '加载中...',
                background: 'rgba(255, 255, 255, 0.5)'
            });        
            return loading;
        },
        submitForm(data){
            this.resultShow = true;
            this.paramsData = data;
            this.size = 20;
            this.page = 1;
            this.queryList();
        },
        async queryList(){
            let vm = this,
                params =vm.getQueryMsg()
                params['size'] = vm.size;
                params['current'] = vm.page;
                vm.tableLoading = vm.loading();
                let res = await getsearchresult(params)
                if(res.code == '200'){
                    vm.tableLoading.close();
                    let data = res.data,
                        entities = data.records || [],
                        len = entities.length;
                    vm.total0 = data.total;
                 
                    if(!data.records) data.records = [];
                    vm.tableParam.dataRes.entities = entities;
                    vm.total = data.total;

                    vm.$nextTick(()=>{                     
                        let sellist = [];
                        data.records.forEach((ele, i) => {
                            vm.choosedData.forEach(element => {
                                if(ele.gid == element.gid){
                                    sellist.push(ele);
                                }
                            });
                        });
                            vm.$refs.reptable.toggleSelection(sellist);
                        });
                }else{
                    vm.tableLoading.close();
                    this.$message({
                        message:res.msg,
                        type: "error",
                        duration:800
                    });
                    
                }
            },
            tableChange(data) {
                let vm = this;
                if(data.event == 'toDetail') {//详情
                    let routeUrl = this.$router.resolve({
                        name: "BookDetail",
                        params: { goodsId: data.row.goodsId }
                    });
                    window.open(routeUrl.href, '_blank');
                }else if(data.event == 'selectSomeone'){  //点击勾选、取消勾选
                    //如果点击的那行数据 在所有已勾选数据中存在，那么去掉这行数据；否则就添加此行数据                    
                    if(vm.getGids(vm.choosedData).indexOf(data.row.gid) > -1){
                        vm.choosedData.splice(vm.getGids(vm.choosedData).indexOf(data.row.gid), 1);
                    }else{
                        data.row.choosed = true;
                        vm.choosedData.push(data.row);
                    }
                }else if(data.event == 'selectAll'){  //点击全选、全不选 功能
                    if(data.row.length > 0){  //全选
                        let dataGid = vm.getGids(data.row);
                        let cGid = vm.getGids(vm.choosedData);
                        for(var a = 0; a < dataGid.length; a++){
                            if(cGid.indexOf(dataGid[a]) < 0){
                                vm.choosedData.push(data.row[a]);
                            }
                        }
                    }else{  //全不选
                        let d = vm.tableParam.dataRes.entities;
                        for(var a = 0; a < d.length; a++){
                            let i = vm.getGids(vm.choosedData).indexOf(d[a].gid);
                            if(i > -1) vm.choosedData.splice(i, 1);
                        }
                    }
                }else if(data.event == 'spaceKey'){ //空格键 勾选、取消勾选
                    if(vm.getGids(vm.choosedData).indexOf(data.row.gid) > -1){
                        vm.choosedData.splice(vm.getGids(vm.choosedData).indexOf(data.row.gid), 1);
                    }else{
                        data.row.choosed = true;
                        vm.choosedData.push(data.row);
                    }
                }
            },
            handleSizeChange(val) {
                let vm = this;
                vm.page = 1;
                vm.size = val;
                vm.queryList();
            },
            handleCurrentChange(val) {
                let vm = this;
                vm.page = val;
                vm.queryList();
            },
             // 通过选中数组获取选中的gid
            getGids(arr = []){
                if(arr.length < 1) return [];
                let gids = [];
                for(let i = 0; i < arr.length; i++){
                    gids.push(arr[i].gid || arr[i]);
                }
                return gids;
            }, 
            getGoodsGid(arr = []){
                if(arr.length < 1) return [];
                let gids = [];
                for(let i = 0; i < arr.length; i++){
                    gids.push(arr[i].goodsId);
                }
                return gids;
            },
            //判断对象为空
            emptyObj(obj) {
                let bool = false;
                for(let x in obj){
                    if(!(obj[x] === null || obj[x] === undefined || obj[x] === false || obj[x].length == 0)){
                        bool = true;
                        break;
                    }
                }
                return bool
            },
            // 清空已勾选数据
            clearCheck(){
                let vm = this,
                    listtab  = vm.tableParam.dataRes.entities;
                vm.myTotal = 0;
                vm.choosedData = [];
                vm.$refs.reptable.toggleSelection([]);
            },
            // 展示购物车数据
        async getShopCarData() {
            let data = {
                userId: Cookies.get("UserID"),
                source:Cookies.get("source")
            };
            let res = await shoppingCartnum(data)
            if(res.code == '200'){
                this.$store.state.DataStorage.GoodLengthData = res.data;
            }
        },

             addInvent() {
                let vm = this,
                    checked = vm.choosedData,
                    _gids=vm.getGoodsGid(checked);
                    
                if(_gids.length == 0){
                    this.$message({
                        message: '请选择要加入购物车的书目！',
                        type: 'info'
                    })                   
                }else if(!Cookies.get('token')){
                    localStorage.setItem('pageUrl', `/${window.location.hash}`);
                    this.$router.push({ name: 'Login' })
                }else{
                    vm.addivent_pop = popup('<add-inventory @cancel="close" @submit="submit" :objdata="objData"/>',{
                        option: {
                            title:'设置采购数量',
                            width:'433px',
                            customClass: 'pop-add-list'
                        },
                        popup: {
                            data(){
                            
                                return {
                                    objData: {                                     
                                        gids:_gids
                                    }
                                }
                            },
                            components: {
                                AddInventory
                            },
                            methods: {
                                submit(data){
                                    vm.addivent_pop.hide();
                                    vm.queryList();
                                    vm.clearCheck();
                                    vm.getShopCarData()

                                },
                                close(data){
                                    vm.addivent_pop.hide();
                                }
                            }
                        }
                    })
                    vm.addivent_pop.show();
                }
            },
            returnMsg(){//全部加入购物车后
                
            }

    },
    components: {
      BottomComponent,
      TopComponent,
      TableList,
      Tooltip,
      SearchComponent,
      'el-button':Button,
      'el-tooltip': Tooltip,
      AddCarAll,
      Sort,
      'el-pagination':Pagination,
    }
  }
</script>

<style scoped lang="scss">
  .SearchResult {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }
  .opera_c{
      height: 40px;
  }
  .jsd{
      float:left;
      margin-top: 5px;
      margin-right: 10px;
  }
  .sortbox{
      float:left;
  }
  .numdetail{
      font-size: 16px;
  }

  /* 1 */
  .Coalition-title {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .Coalition-title-font {
    width: 1230px;
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: calc(50% - 590px);
    color: rgba(0, 0, 0, 1);
    font-size: 24px;
    font-weight: 600;
  }

  /* 2 */
  .Coalition-content {
    width: 1180px;
    /* height: 500px; */
    margin-left: calc(50% - 600px);
  }

  .Coalition-contentFor {
    margin-top: 20px;
  }

  .Coalition-contentFor-title {
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    margin-left: 5px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .Coalition-contentFor-content {
    width: 190px;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    border-radius: 4px;
    margin-left: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    margin-top: 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/search/SearchResult.vue